export default {
  init() {

    let sticky = document.getElementById('sticky-header').offsetTop;
    window.onscroll = function () {
      if (window.pageYOffset > sticky) {
        $('#sticky-header').addClass('sticky-selection');
      } else {
        $('#sticky-header').removeClass('sticky-selection');
      }
    };

    $('.read-more-button').on('click', function () {
      let showMore = $(this);

      if (showMore.hasClass('show-less')) {
        $('.read-more-dots').removeClass('hidden');
        $('.show-more-second-part').addClass('hidden');
        showMore.removeClass('show-less').html('Show more');
      } else {
        $('.read-more-dots').addClass('hidden');
        $('.show-more-second-part').removeClass('hidden');
        showMore.addClass('show-less').html('Show less');
      }
    });

    $('.media-thumbnails a').on('click', function (event) {
      event.preventDefault();

      let href = $(this).attr('href');
      let video = $(this).hasClass('video');
      let title = $(this).attr('media-title');
      let description = $(this).attr('media-description');
      let mediaDesc = '';
      if (title !== undefined && title !== '') {
        mediaDesc = title;
      }
      if (description !== undefined && description !== '') {
        mediaDesc = mediaDesc + ' - ' + description;
      }
      let image = '<img class="m-auto" src="' + href + '" />';
      let caption = '<span class="pb-3 pt-0 text-ultra-black">' + mediaDesc + '</span>';
      $(this).addClass('active').parent().siblings().children('a').removeClass('active');

      if (video) {
        image = '<iframe src="' + href + '" frameborder="0" scrolling="no" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>';
      }

      $('.media-image-large').html(image);
      $('.media-image-large-title').html(caption);
    });

    //One vs One
    function postNonObjects(path, parameters) {
      let form = $('<form></form>');

      form.attr('method', 'post');
      form.attr('action', path);

      $.each(parameters, function (key, value) {
        var field = $('<input></input>');

        field.attr('type', 'hidden');
        field.attr('name', key);
        field.attr('value', value);

        form.append(field);
      });

      //The form needs to be a part of the document in
      //order for us to be able to submit it.
      $(document.body).append(form);
      form.submit();
    }

    window.postToOneVsOnePage = function (url, productSlug, event) {
      event.preventDefault();
      let params = {
        'product-slug': productSlug,
      }

      postNonObjects('/compare/' + url, params);
    }
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
